import { useSelector } from "react-redux";
import MainMenuRevenue from "./MainMenuRevenue";
import MainMenuEnteringData from "./MainMenuEnteringData";
import ReportsRM from "./ReportsRM";
import EnteringDataRM from "./EnteringDataRM";
import LogsModal from "./LogsModal";


const useComponentRenderer = () => {
  const activeComponent = useSelector((state) => state.RevenueModuleSlice.activeComponent);
  
  const componentMap = {
    'reports': ReportsRM,
    'enteringDataMenu': MainMenuEnteringData,
    'enteringData': EnteringDataRM
  };

  const getComponent = () => {
    if (!activeComponent) return MainMenuRevenue;
    return componentMap[activeComponent] || MainMenuRevenue;
  };

  return {
    Component: getComponent()
  };
};

function MainRevenue() {
  const logs = useSelector((state) => state.RevenueModuleSlice.logs);
  const { Component } = useComponentRenderer();

  if (logs) return <LogsModal />;
  if (Component === null) return null;
  
  return <Component />
}

export default MainRevenue;